import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"
import {padStart} from "lodash"

import Button from "@irati/ui/src/Button"
import {H6} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import getCircuitLogo from "@irati-web/payments/src/helpers/getCircuitLogo"

interface Expiry {
  month: number
  year: number
}

interface Props {
  removePaymentMethod: () => void
  variant: string
  number: string
  expiry: Expiry
  reference: string
}

class UserSavedPaymentCard extends Component<Props> {
  render() {
    const {variant, number, expiry, removePaymentMethod} = this.props
    return (
      <StyledRow>
        <Col xs={3}>
          {getCircuitLogo(variant)}
        </Col>
        <Col xs={3}>
          <H6>•••• {number}</H6>
        </Col>
        <Col xs={3}>
          <H6>{`${padStart(expiry.month.toString(), 2, "0")}/${expiry.year.toString().slice(2)}`}</H6>
        </Col>
        <Col xs={3}>
          <Button destructive onClick={removePaymentMethod}>
            <FormattedMessage id="account.savedCard.remove" />
          </Button>
        </Col>
      </StyledRow>
    )
  }
}

export default UserSavedPaymentCard

const StyledRow = styled(Row)`
  display: flex;
  align-items: center;
`
